import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { allowedTimeExpediteVideoEdit } from '../views/projects/modals/VideoEditStepModal/constants';

const useOrderSameDay = () => {
  const [isAvailable, setIsAvailable] = useState(true);

  useEffect(() => {
    const calculateIsAvailableTime = () => {
      const day = moment().tz('America/Los_Angeles').format('YYYY-MM-DD');

      const nowDate = moment().tz('America/Los_Angeles').format('YYYY-MM-DD HH:mm:ss');
      const timeExpeditingAllowed = `${day} ${allowedTimeExpediteVideoEdit.start}`;
      const timeExpeditingNotAllowed = `${day} ${allowedTimeExpediteVideoEdit.end}`;

      const currentDate = moment(nowDate);
      const allowedStartTime = moment(timeExpeditingAllowed);
      const allowedEndTime = moment(timeExpeditingNotAllowed);
      return (currentDate > allowedStartTime ) || ( currentDate < allowedEndTime) ; // in range
    };
    setIsAvailable(calculateIsAvailableTime());

    const intervalId = setInterval(() => setIsAvailable(calculateIsAvailableTime()), 1000 * 60);

    return () => {
      clearInterval(intervalId);
    };
  }, [setIsAvailable]);

  return isAvailable;
};

export default useOrderSameDay;
